<template>
  <div class="vx-row mb-5">
    <div class="vx-col w-1/2">
      <vs-input
        class="w-full"
        :label-placeholder="`Tujuan Ke-${formKey+1}`"
        v-model="input.nama"
      />
    </div>
    <!-- <div class="vx-col w-1/3">
      <vs-input
        class="w-full"
        :label-placeholder="`Email Tujuan Ke-${formKey+1}`"
        v-model="input.email"
      />
    </div> -->
    <div v-if="formKey == 0" class="vx-col w-1/3">
      <br>
      <vs-button
        v-if="formLength-1 == formKey"
        class="mx-1 rounded-circle"
        color="primary"
        type="filled"
        size="small"
        @click="$emit('addNewForm', formKey)"
      >
        Tambah Tujuan
      </vs-button>
    </div>
    <div v-else class="vx-col w-1/3">
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <br>
          <vs-button
            v-if="formKey !=0"
            class="mx-1 rounded-circle"
            color="danger"
            type="filled"
            size="small"
            @click="$emit('deleteForm', formKey)"
          >
            Hapus Tujuan
          </vs-button>
        </div>
        <div class="vx-col w-1/2">
          <br>
          <vs-button
            v-if="formLength-1 == formKey"
            class="mx-1 rounded-circle"
            color="primary"
            type="filled"
            size="small"
            @click="$emit('addNewForm', formKey)"
          >
            Tambah Tujuan
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultValue : {
      type : Object,
      required : true
    },
    formKey: {
      type: Number,
      required: true
    },
    formLength: {
      type: Number,
      required: true
    },
  },
  data(){
    return {
      input : {
        nama : '',
        email : ''
      }
    }
  },
  watch : {
    input: {
      handler() {
        this.$emit("input", this.input);
      },
      deep: true
    },
    defaultValue: {
      handler(){
        this.input.nama = this.defaultValue.nama;
        this.input.email = this.defaultValue.email;
      },
      deep: true
    }
  },
  mounted(){
    this.setDefaultValue();
  },
  methods : {
    setDefaultValue(){
      this.input.nama = this.defaultValue.nama;
      this.input.email = this.defaultValue.email;
    }
  }
};
</script>

<style>
.flatpickr-calendar.open {
  z-index: 100002;
}
</style>
